function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Invoker = /*#__PURE__*/function () {
  function Invoker(target, func) {
    _classCallCheck(this, Invoker);

    _defineProperty(this, "target", void 0);

    _defineProperty(this, "func", void 0);

    this.target = target;
    this.func = func;
  } // TODO-barret - Don't know how to define the method twice and still have access to "this"


  _createClass(Invoker, [{
    key: "normalCall",
    value: function normalCall() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.func.apply(this.target, args);
    }
  }, {
    key: "immediateCall",
    value: function immediateCall() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.func.apply(this.target, args);
    }
  }]);

  return Invoker;
}();

export { Invoker };